import { List, Map } from 'immutable';

import { ActionTypes } from '../constants/AppConstants';
import BaseStore from './BaseStore';
import TransactionHistoryResults from "../records/customer/keygo/journeyHistory/TransactionHistoryResults";


class KeyGoTransactionsStore extends BaseStore {

    getInitialState () {
        const transactionHistory = new TransactionHistoryResults({ dailyTransactions: new List() });
        const loading = false;
        return new Map({ transactionHistory, loading });
    }

    handleTransactionsLoaded ({ transactionHistory }) {
        const updated = this.state
            .set('transactionHistory', transactionHistory)
            .set('loading', false);
        this.setState(updated);
    }

    get loading () {
        return this.get('loading');
    }

    handleTransactionsLoading () {
        this.setState(this.state.set('loading', true));
    }

    getTransactionHistory () {
        return this.get('transactionHistory');
    }

    getActionHandlers () {
        return {
            [ ActionTypes.KEYGO_TRANSACTIONS_LOADING ]: this.handleTransactionsLoading,
            [ ActionTypes.KEYGO_TRANSACTIONS_LOADED ]: this.handleTransactionsLoaded,
            [ ActionTypes.LOGGED_OUT ]: this.resetState
        };
    }

}

export default new KeyGoTransactionsStore();
